import { useState } from 'react';
import { Operation } from '@/backend/models/operation';
import { I18n } from '@/i18n/I18n';
import { useTreeStore } from '@/frontend/store/TreeStore';

export function NotesItem(props: { operation: Operation }) {
  const { operation } = props;
  const textID = `content-${operation.id}`;
  const [value, setValue] = useState(operation.content || '');
  const updateOperation = useTreeStore(state => state.updateOperation);

  const onBlur = async () => {
    await updateOperation({ 
      operation: { ...operation, content: value }, 
      hideToast: true 
    });
  };

  async function onChangeContent(content: string) {
    setValue(content);
  }

  return (
    <div className="d-flex gap-2 justify-content-center">
      <div className="w-100">
        <div className="form-floating">
          <textarea
            className="form-control form-control-sm"
            id={textID}
            onChange={(e) => void onChangeContent(e.target.value)}
            onBlur={() => void onBlur()}
            value={value as string}
            name='notes-content'
            placeholder={I18n.get('notesPlaceholder')}
          />
          <label htmlFor={textID}>
            <small>{I18n.get('notes')}</small>
          </label>
        </div>
     </div>
    </div>
  );
}
